<template>
    <div>
        <ul :class="{ 'grid' : true, 'grid--loading' : $wait.is('events') }">
            <!-- Error while loading -->
            <li class="grid__error col-12" v-if="error">
                <span class="h2">Unable to load events.</span>
                <button class="btn btn--link" @click.prevent="getEvents">Retry</button>
            </li>

            <template v-if="events.length">
                <li v-for="event in events" class="col-md-6 col-lg-4 col-12">
                    <EventCard :curr-event="event" :flags="true"></EventCard>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import API from '@api';
import EventCard from "../Card";

export default {
    name: 'GridEvents',
    components: {EventCard},
    props: {
        filters: {
            type: Object,
            default: () => ({}),
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Array,
            default: () => [],
        },
    },
    created() {
        this.getEvents();
    },
    data() {
        return {
            events: [],
            error: false,
            selected: [],
        }
    },
    methods: {
        getEvents() {
            this.$wait.start('events');

            API.getEvents({'per_page': 100, 'sort': "name|asc"}).then(response => {
                console.log(response);
                this.error = false;
                this.events = response;
            }).catch(() => {
                this.error = true;
            }).finally(() => this.$wait.end('events'));
        },
    },
    watch: {
        selected() {
            this.$emit('input', this.selected);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~reflex-grid/scss/includes/variables";
@import "~reflex-grid/scss/includes/mixins";
@import "~@/theme/_variables.scss";

.card {
    @include flex-direction(column);

    label {
        padding: 2rem;
        cursor: pointer;
        min-height: 0;
        border: 0.1rem solid #cfcfcf;
        border-radius: 0.4rem;
        @include flex(1, 1, auto);
        @include align-self(stretch);
        @include display-flex;
    }

    input:checked + label {
        border-color: $accent;
        border-radius: 0.2rem;
    }
}
</style>
